import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { landingPageRouteElements } from './landingPageRoutes';

const LandingPage = lazy(() => import('../pages/LandingPage'));
const SignupForm = lazy(() => import('../components/auth/SignupForm'));
const LoginPage = lazy(() => import('../pages/LoginPage'));
const OnAirPage = lazy(() => import('../pages/OnAirPage'));
const HelpIndex = lazy(() => import('../pages/help/HelpIndex'));
const ArticleAudioHijack = lazy(() => import('../pages/help/ArticleAudioHijack'));
const ArticleLoopback = lazy(() => import('../pages/help/ArticleLoopback'));
const ArticleBackgroundMusic = lazy(() => import('../pages/help/ArticleBackgroundMusic'));
const ArticleBlackhole = lazy(() => import('../pages/help/ArticleBlackhole'));
const ArticleVirtualAudioCable = lazy(() => import('../pages/help/ArticleVirtualAudioCable'));
const ArticleVbCable = lazy(() => import('../pages/help/ArticleVbCable'));
const ArticleVoicemeeterBanana = lazy(() => import('../pages/help/ArticleVoicemeeterBanana'));
const ArticleObsWhip = lazy(() => import('../pages/help/ArticleObsWhip'));
const ArticleSmartphoneLive = lazy(() => import('../pages/help/ArticleSmartphoneLive'));
const ArticleStudioAudiovisuel = lazy(() => import('../pages/help/ArticleStudioAudiovisuel'));
const TermsPage = lazy(() => import('../pages/TermsPage'));
const PrivacyPage = lazy(() => import('../pages/PrivacyPage'));
const FaqPage = lazy(() => import('../pages/FaqPage'));

/** Routes marketing publiques (montées sous / et /en). */
export const marketingRouteElements = (
  <>
    <Route index element={<LandingPage />} />
    <Route path="signup" element={<SignupForm />} />
    <Route path="login" element={<LoginPage />} />
    <Route path="on-air" element={<OnAirPage />} />
    <Route path="help" element={<HelpIndex />} />
    <Route path="help/audio-hijack" element={<ArticleAudioHijack />} />
    <Route path="help/loopback" element={<ArticleLoopback />} />
    <Route path="help/background-music" element={<ArticleBackgroundMusic />} />
    <Route path="help/blackhole" element={<ArticleBlackhole />} />
    <Route path="help/virtual-audio-cable" element={<ArticleVirtualAudioCable />} />
    <Route path="help/vb-cable" element={<ArticleVbCable />} />
    <Route path="help/voicemeeter-banana" element={<ArticleVoicemeeterBanana />} />
    <Route path="help/voicemeeter" element={<Navigate to="../help/voicemeeter-banana" replace />} />
    <Route path="help/obs-whip" element={<ArticleObsWhip />} />
    <Route path="help/smartphone-live" element={<ArticleSmartphoneLive />} />
    <Route path="help/studio-audiovisuel-a-distance" element={<ArticleStudioAudiovisuel />} />
    <Route path="faq" element={<FaqPage />} />
    <Route path="tarifs" element={<Navigate to="../signup" replace />} />
    {landingPageRouteElements}
    <Route
      path="solutions/studio-audiovisuel-a-distance"
      element={<Navigate to="../studio-audiovisuel-a-distance" replace />}
    />
    <Route path="terms" element={<TermsPage />} />
    <Route path="privacy" element={<PrivacyPage />} />
  </>
);
